import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-modal="container"]',
        close: '[js-modal="close"]',
        open: '[js-modal="open"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        $(nodeSelectors.close).on('click', function () {
            $(nodeSelectors.container).addClass('hidden');
        })

        $(nodeSelectors.open).on('click', function () {
            let target = $(this).data('js-modal--target')
            $(target).removeClass('hidden');
        })
    }

    return Object.freeze({
        init,
        nodeSelectors,
    })
}